import {
  ClickAwayListener,
  Fade,
  Paper,
  Popper
} from '@mui/material';
import useStyles, {
  crossStyles,
  sizePadding,
  sizeStyles,
  titleColors,
} from 'style/js-style/components/common/EAPopperStyle';
import EAIcon from './EAIcon';

/**
 *
 * @param anchorEl : ref of the element for the anchor
 * @param placement : see Placement of popper in MUI
 * @returns
 */
const EAPopper = ({
  open = false,
  children,
  anchorEl,
  placement = 'top',
  title,
  subTitle,
  size = 'medium',
  crossVisible = true,
  titleVariant = 'default',
  onClose = () => {},
}) => {
  const { classes } = useStyles();

  return (
    <>
      {anchorEl && (
        <ClickAwayListener onClickAway={onClose}>
          <Popper
            open={open}
            anchorEl={anchorEl}
            placement={placement}
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  className={classes.popperRoot}
                  sx={{
                    ...sizeStyles[size],
                  }}
                >
                  <>
                    <div
                      className={classes.header}
                      style={{
                        ...titleColors[titleVariant],
                        ...sizePadding[size],
                      }}
                    >
                      <div className={classes.title}>
                        <span style={{ wordBreak: 'break-word' }}>
                          {title}
                          <span style={{ fontWeight: 400 }}>{subTitle}</span>
                        </span>
                      </div>
                      {crossVisible && (
                        <EAIcon
                          icon={titleVariant === 'default' ? 'cross' : 'close'}
                          className={classes.cross}
                          onClick={onClose}
                          style={{ ...crossStyles(size) }}
                        />
                      )}
                    </div>
                    <div style={{ ...sizePadding[size] }}>{children}</div>
                  </>
                </Paper>
              </Fade>
            )}
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
};

export default EAPopper;
